import { Bones } from '@simplywallst/ui-core';

const TopWorstSkeleton = () => (
  <tr data-cy-id="dashboard-top-worst-skeleton">
    <td>
      <span>
        <Bones />
      </span>
    </td>

    <td>
      <span>
        <Bones />
      </span>
    </td>
  </tr>
);

export default TopWorstSkeleton;
